import React, { useState, useEffect } from 'react';
import { Plus, Trash2, ExternalLink, Edit2, Save, X, BarChart2 } from 'lucide-react';
import api from '../../api';

function fmtDate(d) {
  if (!d) return '';
  return new Date(d).toLocaleDateString('it-IT', { day:'numeric', month:'short', year:'numeric' });
}

const PERIODI = [
  'Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno',
  'Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre',
  'Q1','Q2','Q3','Q4',
];

const ANNI = Array.from({ length:5 }, (_, i) => String(new Date().getFullYear() - i));

export default function ReportSection({ clienteId }) {
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ titolo:'', mese:'', anno:'', url:'', note:'' });
  const [saving, setSaving] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editForm, setEditForm] = useState({});

  const load = () =>
    api.get(`/cliente_report/${clienteId}`).then(r => setItems(r.data)).catch(() => {});

  useEffect(() => { load(); }, [clienteId]);

  const periodo = (m, a) => [m, a].filter(Boolean).join(' ');

  const add = async (e) => {
    e.preventDefault();
    if (!form.titolo.trim()) return;
    setSaving(true);
    try {
      const r = await api.post(`/cliente_report/${clienteId}`, {
        titolo: form.titolo,
        periodo: periodo(form.mese, form.anno) || null,
        url: form.url || null,
        note: form.note || null,
      });
      setItems(prev => [r.data, ...prev]);
      setForm({ titolo:'', mese:'', anno:'', url:'', note:'' });
      setShowForm(false);
    } catch {}
    setSaving(false);
  };

  const startEdit = (item) => {
    const parts = (item.periodo || '').split(' ');
    setEditId(item.id);
    setEditForm({ titolo: item.titolo, mese: parts[0]||'', anno: parts[1]||'', url: item.url||'', note: item.note||'' });
  };

  const saveEdit = async (id) => {
    const r = await api.put(`/cliente_report/${id}`, {
      titolo: editForm.titolo,
      periodo: periodo(editForm.mese, editForm.anno) || null,
      url: editForm.url || null,
      note: editForm.note || null,
    });
    setItems(prev => prev.map(x => x.id === id ? r.data : x));
    setEditId(null);
  };

  const del = async (id) => {
    await api.delete(`/cliente_report/${id}`);
    setItems(prev => prev.filter(x => x.id !== id));
  };

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:14 }}>
        <span style={{ fontSize:14, fontWeight:600, color:'var(--text)' }}>
          Report {items.length > 0 && <span style={{ fontSize:12, color:'var(--text-dim)', fontWeight:400 }}>({items.length})</span>}
        </span>
        <button onClick={() => setShowForm(v => !v)} className="eden-btn-primary" style={{ fontSize:12 }}>
          <Plus size={13}/> Nuovo report
        </button>
      </div>

      {showForm && (
        <form onSubmit={add} style={{ background:'var(--bg3)', border:'1px solid rgba(0,212,255,0.2)', borderRadius:10, padding:'14px 16px', marginBottom:14, display:'flex', flexDirection:'column', gap:10 }}>
          <input autoFocus required value={form.titolo} onChange={e => setForm(f => ({ ...f, titolo:e.target.value }))}
            placeholder="Titolo report (es. Report mensile Instagram)" className="eden-input" style={{ fontSize:13 }}/>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
            <select value={form.mese} onChange={e => setForm(f => ({ ...f, mese:e.target.value }))} className="eden-select">
              <option value="">Mese/Periodo</option>
              {PERIODI.map(p => <option key={p} value={p}>{p}</option>)}
            </select>
            <select value={form.anno} onChange={e => setForm(f => ({ ...f, anno:e.target.value }))} className="eden-select">
              <option value="">Anno</option>
              {ANNI.map(a => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <input value={form.url} onChange={e => setForm(f => ({ ...f, url:e.target.value }))}
            placeholder="Link report (Google Drive, Looker, ecc.)" className="eden-input" style={{ fontSize:13 }} type="url"/>
          <textarea value={form.note} onChange={e => setForm(f => ({ ...f, note:e.target.value }))}
            placeholder="Note…" className="eden-input" rows={2} style={{ resize:'vertical', fontSize:13 }}/>
          <div style={{ display:'flex', gap:8 }}>
            <button type="submit" disabled={saving} className="eden-btn-primary" style={{ fontSize:12 }}>
              <Save size={12}/> {saving ? 'Salvo…' : 'Salva report'}
            </button>
            <button type="button" onClick={() => setShowForm(false)}
              style={{ border:'1px solid var(--border)', borderRadius:7, background:'none', color:'var(--text-muted)', cursor:'pointer', padding:'6px 12px', fontSize:12 }}>
              Annulla
            </button>
          </div>
        </form>
      )}

      {items.length === 0 ? (
        <div style={{ textAlign:'center', padding:'40px 0', color:'var(--text-dim)', fontSize:13 }}>
          Nessun report ancora. Crea il primo.
        </div>
      ) : (
        <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
          {items.map(item => (
            <div key={item.id} style={{ border:'1px solid var(--border)', borderRadius:10, padding:'12px 14px', background:'var(--surface)' }}>
              {editId === item.id ? (
                <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
                  <input value={editForm.titolo} onChange={e => setEditForm(f => ({ ...f, titolo:e.target.value }))} className="eden-input" style={{ fontSize:13 }}/>
                  <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8 }}>
                    <select value={editForm.mese} onChange={e => setEditForm(f => ({ ...f, mese:e.target.value }))} className="eden-select">
                      <option value="">Mese/Periodo</option>
                      {PERIODI.map(p => <option key={p} value={p}>{p}</option>)}
                    </select>
                    <select value={editForm.anno} onChange={e => setEditForm(f => ({ ...f, anno:e.target.value }))} className="eden-select">
                      <option value="">Anno</option>
                      {ANNI.map(a => <option key={a} value={a}>{a}</option>)}
                    </select>
                  </div>
                  <input value={editForm.url} onChange={e => setEditForm(f => ({ ...f, url:e.target.value }))} className="eden-input" style={{ fontSize:13 }} type="url" placeholder="Link report"/>
                  <textarea value={editForm.note} onChange={e => setEditForm(f => ({ ...f, note:e.target.value }))} className="eden-input" rows={2} style={{ resize:'vertical', fontSize:13 }}/>
                  <div style={{ display:'flex', gap:8 }}>
                    <button onClick={() => saveEdit(item.id)} className="eden-btn-primary" style={{ fontSize:12 }}><Save size={12}/> Salva</button>
                    <button onClick={() => setEditId(null)} style={{ border:'1px solid var(--border)', borderRadius:7, background:'none', color:'var(--text-muted)', cursor:'pointer', padding:'5px 10px', fontSize:12 }}>Annulla</button>
                  </div>
                </div>
              ) : (
                <div style={{ display:'flex', alignItems:'flex-start', gap:12 }}>
                  <div style={{ width:36, height:36, borderRadius:8, background:'var(--cyan-dim)', display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
                    <BarChart2 size={16} color="var(--cyan)"/>
                  </div>
                  <div style={{ flex:1, minWidth:0 }}>
                    <div style={{ fontSize:13, fontWeight:600, color:'var(--text)', marginBottom:2 }}>{item.titolo}</div>
                    <div style={{ display:'flex', gap:8, flexWrap:'wrap', alignItems:'center', marginBottom: item.note ? 6 : 0 }}>
                      {item.periodo && <span style={{ fontSize:11, color:'var(--cyan)', background:'var(--cyan-dim)', padding:'1px 8px', borderRadius:20 }}>{item.periodo}</span>}
                      <span style={{ fontSize:10.5, color:'var(--text-dim)' }}>{fmtDate(item.created_at)}</span>
                    </div>
                    {item.note && <div style={{ fontSize:12, color:'var(--text-muted)', lineHeight:1.6 }}>{item.note}</div>}
                  </div>
                  <div style={{ display:'flex', gap:6, flexShrink:0 }}>
                    {item.url && (
                      <a href={item.url} target="_blank" rel="noreferrer"
                        style={{ display:'flex', alignItems:'center', gap:4, fontSize:11, color:'var(--cyan)', border:'1px solid rgba(0,212,255,0.3)', borderRadius:6, padding:'4px 10px', textDecoration:'none' }}>
                        <ExternalLink size={11}/> Apri
                      </a>
                    )}
                    <button onClick={() => startEdit(item)}
                      style={{ border:'1px solid var(--border)', borderRadius:6, padding:'4px 8px', background:'none', color:'var(--text-dim)', cursor:'pointer', display:'flex', alignItems:'center', transition:'color 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.color='var(--cyan)'}
                      onMouseLeave={e => e.currentTarget.style.color='var(--text-dim)'}>
                      <Edit2 size={11}/>
                    </button>
                    <button onClick={() => del(item.id)}
                      style={{ border:'1px solid var(--border)', borderRadius:6, padding:'4px 8px', background:'none', color:'var(--text-dim)', cursor:'pointer', display:'flex', alignItems:'center', transition:'color 0.15s' }}
                      onMouseEnter={e => e.currentTarget.style.color='var(--red)'}
                      onMouseLeave={e => e.currentTarget.style.color='var(--text-dim)'}>
                      <Trash2 size={11}/>
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
